import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { AppService } from 'src/app/core';

@Component({
  selector: 'app-dialog-user',
  templateUrl: './dialog-user.component.html',
  styleUrls: ['./dialog-user.component.scss']
})
export class DialogUserComponent implements OnInit, OnChanges {

  @Input() displayDialog: boolean = false;
  @Input() quienLlama: string;
  @Input() userSelected: any;

  @Output() emitAction: EventEmitter<any> = new EventEmitter<any>();

  es;
  message: string;
  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  confirmedImage: any = null;
  selectedRoles: string[] = ["USER"];
  flagCancel: boolean = false;
  canvas;
  img;
  tipoImg;
  constructor(private appService: AppService) { }

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Hoy',
      clear: 'Borrar'
    }
  }

  ngOnChanges() {
    if (isNullOrUndefined(this.userSelected)) {
      this.limpiarUsuario();
    } else {
      this.userSelected.fechaNacimiento = new Date(this.userSelected.fechaNacimiento);
    }
    if (this.quienLlama == 'editar' && !this.flagCancel) {
      this.checkRoles();
    }
    if (this.quienLlama == 'nuevo') {
      this.selectedRoles = ["USER"];
    }
    this.flagCancel = false;
  }

  save() {
    this.userSelected.newRoles = this.selectedRoles;
    if (this.confirmedImage) {
      if (this.tipoImg != 'image/jpeg') {
        this.userSelected.foto = this.imageConverter(this.previewUrl);
      } else {
        this.userSelected.foto = this.confirmedImage;
      }
    }
    console.log(this.userSelected)
    if (isNullOrUndefined(this.userSelected.id)) {
      this.emitAction.emit({ accion: 'nuevo', data: this.userSelected });
    } else {
      this.emitAction.emit({ accion: 'edit', data: this.userSelected });
    }
    this.flagCancel = true;
    this.limpiarUsuario();
  }
  cancel() {
    this.flagCancel = true;
    this.emitAction.emit({ accion: 'cancel' });
    this.displayDialog = false;
    this.limpiarUsuario();
  }
  limpiarUsuario() {
    this.userSelected = {
      nombre: '',
      apellido: '',
      mail: '',
      usuario: '',
      fechaNacimiento: new Date(),
      id: undefined,
    };
    this.selectedRoles = null;
    this.previewUrl = null;
    this.confirmedImage = null;
  }
  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }
  preview() {
    // Show preview 
    this.tipoImg = this.fileData.type;
    if (this.tipoImg.match(/image\/*/) == null) {
      this.message = "No es un tipo de imagen válido."
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.message = '';
      this.previewUrl = reader.result;
    }

  }
  savePhoto() {
    this.confirmedImage = this.previewUrl;
  }
  cancelPhoto() {
    this.previewUrl = null;
  }
  checkRoles() {
    if (isNullOrUndefined(this.userSelected.newRoles)){
      let arrPermisos: string[] = new Array();
      this.userSelected.roles.forEach(element => {
        arrPermisos.push(element.role);
      });
      this.selectedRoles = arrPermisos;
    }else{
      this.selectedRoles = this.userSelected.newRoles;
    }
  }

  imageConverter(imagen) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    canvas.width = 200;
    canvas.height = 200;
    let image = new Image();
    image.src = imagen;
    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
    this.confirmedImage = canvas.toDataURL("image/jpeg");
    return this.confirmedImage;
  }
}
